import { z } from 'zod';

export const createServiceTypeSchema = z.object({
  label: z.string().min(2, 'Label is required'),
  description: z.string().min(2, 'Description is required'),
  billable_rate: z
    .number({ error: 'Billable rate is required' })
    .min(0, 'Billable rate must be at least 0'),
});

export const createServiceGroupSchema = z.object({
  name: z.string().min(2, 'Name is required'),
  description: z.string(),
});
